import adminApi from "./adminApi";


export async function getTasks() {
  const response = await adminApi.get("/tasks");

  return response.data || [];
}


export async function createTask(data) {

  const response = await adminApi.post(
    "/tasks",
    data
  );

  return {
    ...response.data,
    comments: [],
    attachments: [],
  };
}


export async function updateTask(id, updates) {

  const response = await adminApi.put(
    `/tasks/${id}`,
    updates
  );

  return response.data;
}


export async function deleteTask(id) {

  await adminApi.delete(
    `/tasks/${id}`
  );

}


export async function uploadAttachment(taskId, file) {

  const formData = new FormData();

  formData.append(
    "file",
    file
  );


  const response = await adminApi.post(
    `/tasks/${taskId}/attachments`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );


  return response.data.attachment;
}


export async function deleteAttachment(id) {

  await adminApi.delete(
    `/tasks/attachments/${id}`
  );

}


export async function addComment(taskId, comment) {

  const response = await adminApi.post(
    `/tasks/${taskId}/comments`,
    {
      comment,
    }
  );


  return response.data;
}


export async function deleteComment(id) {

  await adminApi.delete(
    `/tasks/comments/${id}`
  );

}